module.exports = __webpack_public_path__ + "img/logo3.e86b815a.png";